export default "__VITE_ASSET__DprIBJaX__"